import { HttpParams } from '@angular/common/http';

const STOP_OPTIMIZATION_PARAM = "stopOptimization";

export class StopOptimizationHttpParams {
    private readonly httpParams: HttpParams;

    constructor(public stopOptimization: boolean) {
        this.httpParams = new HttpParams();
        this.httpParams.set(STOP_OPTIMIZATION_PARAM, stopOptimization);
    }

    public getHttpParams() {
        return this.httpParams;
    }
}
